namespace $.$$ {
	export class $shm_hitalama_components_drafts_list extends $.$shm_hitalama_components_drafts_list {
		add_buttons() { return this.model().can_change() ? super.add_buttons() : [] }
		rows() {
			const query = this.filter().trim().toLowerCase()
			const ids = this.model().ids().filter( id => this.entry_title( id ).toLowerCase().includes( query ) )
			ids.sort( ( a, b )=> this.entry_title( a ).localeCompare( this.entry_title( b ) ) )
			if( this.sort_order() === 'desc' ) ids.reverse()
			return ids.length ? ids.map( id => this.Entry( id ) ) : [ this.Empty() ]
		}
		entry_title( id: string ) {
			return this.model().title( id ).trim()
				|| this.model().text( id ).split( /\r?\n/, 1 )[0].trim()
				|| 'Новый черновик'
		}
		current( id: string ) { return this.selected() === id }
		empty_label() { return this.filter().trim() ? 'Ничего не найдено' : 'Черновиков нет' }
		@ $mol_action
		create( event?: Event | null ) {
			if( !event ) return null
			const id = $mol_wire_sync( this.model() ).create( event )
			this.selected( id )
			this.created( event )
			return null
		}
		@ $mol_action
		choose( id: string, event?: Event | null ) {
			if( event ) { this.selected( id ); this.opened( event ) }
			return null
		}
	}
}
